import { AnchorHTMLAttributes, forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Link as MuiLink, LinkProps } from '@mui/material';

export default forwardRef<HTMLAnchorElement, LinkProps>(function LinkCell({ children, ...rest }: LinkProps, ref) {
  return (
    <MuiLink
      ref={ref}
      component={forwardRef<HTMLAnchorElement, AnchorHTMLAttributes<HTMLAnchorElement>>(({ href, ...rest }, forwardedRef) => (
        <RouterLink ref={forwardedRef} to={String(href)} {...rest} />
      ))}
      {...rest}
    >
      {children}
    </MuiLink>
  );
});
